<template>
    <article>
        <p>
            <a href="https://github.com/coroot/coroot-aws-agent" target="_blank">Aws-agent</a> is a Prometheus exporter
            that discovers AWS services such as RDS and Elasticache instances within a specified AWS region.
            It then instruments them with the appropriate metrics exporters:
        </p>

        <ul>
            <li><a href="/docs/metric-exporters/pg-agent/overview" target="_blank">Postgres</a></li>
            <li><a href="https://github.com/prometheus/memcached_exporter" target="_blank">Memcached</a></li>
            <li><a href="https://github.com/oliver006/redis_exporter" target="_blank">Redis</a></li>
        </ul>

        <p>In addition, <var>aws-agent</var> gathers:</p>

        <ul>
            <li>OS metrics (based on <a href="https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_Monitoring.OS.overview.html" target="_blank">Enhanced Monitoring</a>)</li>
            <li>
                <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent', item: 'metrics'}, hash:'#aws_rds_log_messages_total'}" target='_blank'>Log-based metrics</router-link>
            </li>
            <li>
                <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent', item: 'metrics'}, hash:'#aws_rds_info'}" target='_blank'>Meta information</router-link> of the RDS instance
            </li>
        </ul>

        <h2>License</h2>
            <p>
                Coroot-aws-agent is licensed under the <a href="https://github.com/coroot/coroot-aws-agent/blob/main/LICENSE" target="_blank">Apache License, Version 2.0</a>.
            </p>
    </article>
</template>

<script>

export default {
    components: {}

}
</script>

<style scoped>
</style>
